module.exports = __webpack_public_path__ + "static/media/check.7a28852c.svg";